@layer reset, default, desktop;

@layer reset {
  :host {
    display: block;

    * {
      margin: 0;
      box-sizing: border-box;
    }

    ul {
      padding: 0;
    }
  }
}

@layer default {
  :host .gcds-top-nav .gcds-top-nav__container {
    display: flex;
    flex-direction: column;
    width: 90%;
    max-width: var(--gcds-top-nav-max-width);
    margin-inline: auto;
  }
}

@layer desktop {
  /* Note: viewport specific style decisions */
  @media only screen and (width >= 64em) {
    :host .gcds-top-nav {
      border-block-end: var(--gcds-top-nav-border-width) solid
        var(--gcds-top-nav-border-color);

      .gcds-top-nav__container {
        flex-direction: row;
        align-items: flex-end;
      }

      .nav-container__list {
        display: flex;
        align-items: flex-end;
        width: fit-content;

        &.nav-list--right {
          margin-inline-start: auto;
        }

        &.nav-list--center {
          margin-inline: auto;
        }
      }
    }
  }
}
